import React from 'react'
import ZoneHeadTC from '../../features/zoneHead/ZoneHeadTC'

const ZoneHeadTCPage = () => {
    return <ZoneHeadTC />
}

export default ZoneHeadTCPage